(function () {
  "use strict";

  eclipseApp.controller('changeTechInstallCtrl', ['$http', '$rootScope', '$scope', '$state', 'uteEndpoint', 'uteModal', 'changeTechInstallService', 'commonService', 'buyService', 'buyUtils', 'accountDashboardManager', 'dtmService', 'dtmServiceConstants', function ($http, $rootScope, $scope, $state, uteEndpoint, uteModal, changeTechInstallService, commonService, buyService, buyUtils, accountDashboardManager, dtmService, dtmServiceConstants) {

    //
    //--- INITS ----------------------------------------------
    //
    $scope.fulfillment = {};
    $scope.inout = {};
    $scope.timeSlots = [];

    $scope.inout.techInstall = $scope.techInstall || {};

    $scope.fulfillment.loading = true;

    if (!changeTechInstallService.currentTechInstallAppointment || !changeTechInstallService.currentTechInstallAppointment.appointmentDate) {

      // handle page refresh
      $state.go('myAccount');
    }

    $scope.openSubmitModal = function () {
      uteModal.open({
        templateUrl: 'modules/my-account/internet/change-appointment-success-modal.html',
        size: 'lg',
        controller: ['$scope', '$rootScope', 'changeTechInstallService', '$modalInstance', '$state', 'uteLocale', function ($scope, $rootScope, changeTechInstallService, $modalInstance, $state, uteLocale) {

          $scope.close = function () {

            $modalInstance.close();

            $state.go('myAccount');

          };
          $scope.language = uteLocale.language;

          $scope.loadError = !changeTechInstallService.newTechInstallChangeSuccessful;

          if (!$scope.loadError) {
            $scope.currentTechInstallAppointment = changeTechInstallService.newTechInstallAppointment;
            dtmService.complete(dtmServiceConstants.dtmRules.changeAppointment.name);
          }else{
            var dtmServerSideError = 'SS|' + dtmServiceConstants.dtmRules.changeAppointment.defaultServerError;
            dtmService.setVar(dtmServiceConstants.dtmRules.changeAppointment.eVar, dtmServerSideError);
            dtmService.direct(dtmServiceConstants.dtmRules.changeAppointment.errorRuleName);
          }
        }]
      });
    };

    $scope.submitChangeAppointment = function () {

      console.log('----SUBMIT CHANGE APPT ($scope, changeTechInstallService)', $scope, changeTechInstallService);

      if ($scope.inout.techInstall.slot) {

        _.findKey($scope.timeSlots, function (slots) {
          _.each(slots, function (slot) {
            if (slot.slotIndex === $scope.inout.techInstall.slot.slotIndex) {
              $scope.selectedTime = slot;
            }
          });
        });

        if ($scope.selectedTime) {
          console.log('-- SLOT FOUND ($scope)', $scope);
          $scope.selectedDateInfo = {
            workOrderID: $scope.inout.techInstall.workOrderId,
            accountNumber: $rootScope.userInfo.accounts[0].accountNumber,
            selectedSlotId: $scope.selectedTime.slotIndex,
            contactNumber: buyUtils.formatPhoneNumber($scope.inout.techInstall.phone),
            comments: $scope.inout.techInstall.instructions || ''
          };

          changeTechInstallService.newTechInstallAppointment = $scope.selectedTime;
          changeTechInstallService.newTechInstallAppointment.appointmentDate = $scope.selectedTime.startTime;

          accountDashboardManager.confirmChangeTechAppointment($scope.selectedDateInfo).then(function (resp) {

            $scope.openSubmitModal();

          }, function () {

            $scope.openSubmitModal();

          });
        }
      }
    };

  }]);
})();
